<template>
  <div>
    <user-alert-editor-modal
        v-if="alert"
        :alert="alert"
        @alert-resolved="alertResolved"
        @close="alert = null"
    />
  </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";
import UserAlert from '@/components/user/alert/UserAlert'
import UserAlertEditorModal from "@/components/user/alert/UserAlertEditorModal"
import {restApi} from "../../mixins/RestApiMixin"

export default {
    name: 'UserAlertMap',
    components: {UserAlertEditorModal},
    mixins: [mapHelper, restApi],
    props: {
        map: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            timer: null,
            alerts: [],
            alert: null,
            refetch: true
        }
    },
    watch: {
        map() {
          if (this.map) {
              this.$nextTick(() => this.fetchUserAlerts())
          }
        },
        alerts() {
            this.drawAlerts()
        }
    },
    mounted() {
        this.fetchUserAlerts()
    },
    beforeUnmount: function () {
        this.refetch = false
        if (this.timer) {
            clearTimeout(this.timer)
        }
    },
    methods: {
        editAlert: function (alertId) {
            this.alert = this.alerts.find(item => item.id === alertId)
        },
        drawAlerts() {
            if (this.map) {
                this.map.removeMapMarkerByType(this.USER_ALERT)
                let icon = this.map.getMarkerStore().getAlertMarkerIcon()
                this.alerts.forEach(alert => {
                    if (alert.location) {
                        this.map.showMapMarker(alert.id, this.USER_ALERT, alert.location.y, alert.location.x, icon)
                    }
                })
            }
        },

        alertResolved() {
            this.alert = null
            this.fetchUserAlerts()
        },

        async fetchUserAlerts() {
            if (this.timer) {
                clearTimeout(this.timer)
            }
            try {
                this.alerts = await UserAlert.fetch(this, false)
            } catch (e) {
                // Fetch failed
            }
            if (this.refetch) {
                this.timer = setTimeout(this.fetchUserAlerts, 30000)
            }
        }
    }
}
</script>

<style scoped>

</style>
